export function isValidUSPhoneNumber(phoneNumber: string): boolean {
  // Define a regular expression pattern for US phone numbers
  const usPhoneNumberPattern = /^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/;

  // Check if the input matches the pattern
  return usPhoneNumberPattern.test(phoneNumber);
}
